<script>
import {cloneDeep} from 'lodash';
import {mapState} from "vuex";
import {FormWizard, TabContent} from "vue-form-wizard";

export default {
  name: "pricePackageForm",
  components: {
    FormWizard,
    TabContent
  },
  props: {
    editPackage: {
      type: Object,
      default: () => ({})
    },
    packageNumber: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      showModal: true,
      currentPackage: {
        name: 'Package 1',
        total_net_price: 0,
        currency: 'EUR',
        price_package_items: [
          {
            post_type: '',
            social_network: '',
            net_price: 0,
            quantity: 0,
            giveaway: false,
            event: false
          }
        ]
      },
      itemLengthError: false,
      singlePackageError: false,
      nameError: false,
      totalPriceError: false,
      discountError: false,
      packageItems: [],
      selectedItems: []
    }
  },
  watch: {
    packageNumber(newVal) {
      this.currentPackage.name = `Package ${newVal}`;
    }
  },
  computed: {
    ...mapState('pricing', {
      pricePackages: (state) => state.pricePackages,
      pricelist: (state) => state.pricelist
    }),
    isEdit() {
      return Object.keys(this.editPackage).length > 0;
    },
    modalTitle() {
      return this.isEdit ? `Edit "${this.currentPackage.name}" price package` : 'Create new price package';
    },
    firstStepItemsSelected() {
      return this.packageItems.find(item => item.selected);
    }

  },
  mounted() {
    this.packageItems = cloneDeep(this.pricelist).map(item => {
      return {
        ...item,
        selected: false
      }
    });

    // if component has provided editPackage prop
    if (this.isEdit) {
      this.currentPackage = cloneDeep(this.editPackage);
      // set selected field to true for price items that exist in editPackage
      this.packageItems.forEach(item => {
        const match = this.currentPackage.price_package_items.find(price => {
          return item.price_package_items[0].giveaway === price.giveaway &&
              item.price_package_items[0].event === price.event &&
              item.price_package_items[0].post_type === price.post_type &&
              item.price_package_items[0].social_network === price.social_network;
        });
        if (match) {
          item.price_package_items[0].quantity = match.quantity;
          item.selected = true;
        }
      });
    }
    if (this.editPackage.name) {
      this.currentPackage.name = this.editPackage.name;
    } else {
      this.currentPackage.name = `Package ${this.packageNumber}`;
    }
  },
  methods: {
    savePackage(bvModalEvt) {
      if (this.isFormValid()) {
        this.$emit('saved', this.currentPackage);
      } else {
        bvModalEvt.preventDefault();
      }
    },
    isFormValid() {
      let isValid = true;
      if (this.currentPackage.name === '') {
        this.nameError = true;
        isValid = false;
      }
      if (!this.isValidNumber(this.currentPackage.total_net_price)) {
        this.totalPriceError = true;
        isValid = false;
      }
      if (this.currentPackage.total_net_price >= this.sum(this.currentPackage)) {
        this.discountError = true;
        isValid = false;
      }

      return isValid;
    },
    isValidNumber(number) {
      return (typeof number) === 'number' && number > 0;
    },
    modalClosed() {
      this.$emit('closed');
    },
    prevTab() {
      this.$refs.formWizard.prevTab();
    },
    nextTab() {
      this.$refs.formWizard.nextTab();
    },
    validateItems() {
      this.selectedItems = this.packageItems.filter(item => item.selected);
      if (this.selectedItems.length === 0) {
        this.itemLengthError = true;
        return false;
      }
      this.itemLengthError = false;
      return true;
    },
    validateQuantity() {
      this.currentPackage.price_package_items = this.selectedItems.map(item => item.price_package_items[0]);
      if (this.currentPackage.price_package_items.length === 1 && this.currentPackage.price_package_items[0].quantity <= 1) {
        this.singlePackageError = true;
        return false;
      }
      this.singlePackageError = false;
      return true;
    },
    select() {

    },
    sum(pack) {
      return pack.price_package_items.reduce((acc, item) => acc + item.net_price * item.quantity, 0);
    }
  },
}
</script>

<template>
  <div>
    <b-modal @hidden="modalClosed" v-model="showModal" :title="modalTitle" size="lg" centered hide-footer>
      <form-wizard ref="formWizard" color="#01baf1">
        <tab-content title="Items" :before-change="validateItems">
          <div class="row">
            <div class="col-12 text-center mb-4">
              <div>
                <h5 class="mb-4"> Select items for price package</h5>
                <div class="d-none d-md-block py-1 px-2 mb-2 pricing-header-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-md text-center">
                      <p class="text-muted mb-0">{{ $t('Platform') }}</p>
                    </div>
                    <div class="col-6 col-md text-center">
                      <p class="text-muted mb-0">{{ $t('Post type') }}</p>
                    </div>
                    <div class="col text-center">
                      <p class="text-muted mb-0">{{ $t('Giveaway') }}</p>
                    </div>
                    <div class="col text-center">
                      <p class="text-muted mb-0">{{ $t('Event') }}</p>
                    </div>
                    <div class="col-6 col-md text-center">
                      <p class="text-muted mb-0">{{ $t('Price') }}</p>
                    </div>
                  </div>
                </div>
                <div v-for="(price, key) in packageItems" :key="price._id" class="tab-section selectable p-2 mb-2"
                     :class="{ selected: price.selected }"
                     @click="price.selected = !price.selected; itemLengthError = false;">
                  <div class="row align-items-center">
                    <div class="col-6 col-md text-center my-md-0 mb-2">
                      <p class="text-muted d-md-none mb-1">{{ $t('Platform') }}</p>
                      <div class="social-image-container d-flex align-items-center justify-content-center">
                        <img v-if="price.price_package_items[0].social_network === 'instagram'"
                             src="@/assets/images/brands/instagram.png" class="img-fluid" style="width:28px;" alt="">
                        <img v-if="price.price_package_items[0].social_network === 'facebook'"
                             src="@/assets/images/brands/facebook.png" class="img-fluid" style="width:28px;" alt="">
                        <img v-if="price.price_package_items[0].social_network === 'youtube'"
                             src="@/assets/images/brands/youtube.png" class="img-fluid" style="width:28px;" alt="">
                        <img v-if="price.price_package_items[0].social_network === 'blog'"
                             src="@/assets/images/brands/analytics-logo.png" class="img-fluid" style="width:28px;"
                             alt="">
                      </div>
                    </div>
                    <div class="col-6 mt-2 order-3 order-md-1 mt-md-0 col-md text-center">
                      <p class="text-muted d-md-none mb-1">{{ $t('Post type') }}</p>
                      <h5 class="mb-0"> {{
                          (price.price_package_items[0].post_type.charAt(0).toUpperCase() + price.price_package_items[0].post_type.slice(1)).replace(/_/g, " ")
                        }} </h5>
                    </div>
                    <div class="col-6 col-md order-2 order-md-2 my-md-0 mb-2 text-center">
                      <p class="text-muted d-md-none mb-1">{{ $t('Giveaway') }}</p>
                      <span v-if="price.price_package_items[0].giveaway"
                            class="badge badge-soft-success font-size-12 ml-1 align-bottom">Yes</span>
                      <span v-else class="badge badge-soft-warning font-size-12 ml-1 align-bottom">No</span>
                    </div>
                    <div class="col-6 col-md order-2 order-md-2 my-md-0 mb-2 text-center">
                      <p class="text-muted d-md-none mb-1">{{ $t('Event') }}</p>
                      <span v-if="price.price_package_items[0].event"
                            class="badge badge-soft-success font-size-12 ml-1 align-bottom">Yes</span>
                      <span v-else class="badge badge-soft-warning font-size-12 ml-1 align-bottom">No</span>
                    </div>
                    <div class="col-6 col-md order-4 order-md-3 text-center">
                      <p class="text-muted d-md-none mb-1">{{ $t('Price') }}</p>
                      <h5 class="mb-0"> {{ price.price_package_items[0].net_price.toLocaleString() }} <span
                          style="font-size: 0.85em;">&euro;</span></h5>
                    </div>
                  </div>
                </div>
                <span class="my-2 d-inline-block text-danger"
                      v-if="itemLengthError">You must select at least 1 item.</span>
              </div>
            </div>
          </div>
        </tab-content>

        <tab-content title="Quantity" :before-change="validateQuantity">
          <div class="row">
            <div class="col-12 text-center mb-4">
              <div>
                <h5 class="mb-4"> Choose quantity</h5>
                <div class="d-none d-md-block py-1 px-2 mb-2 pricing-header-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-md text-center">
                      <p class="text-muted mb-0">{{ $t('Platform') }}</p>
                    </div>
                    <div class="col-6 col-md text-center">
                      <p class="text-muted mb-0">{{ $t('Post type') }}</p>
                    </div>
                    <div class="col text-center">
                      <p class="text-muted mb-0">{{ $t('Giveaway') }}</p>
                    </div>
                    <div class="col text-center">
                      <p class="text-muted mb-0">{{ $t('Event') }}</p>
                    </div>
                    <div class="col-6 col-md text-center">
                      <p class="text-muted mb-0">{{ $t('Price') }}</p>
                    </div>
                    <div class="col-6 col-md text-center">
                      <p class="text-muted mb-0">{{ $t('Quantity') }}</p>
                    </div>
                  </div>
                </div>
                <div v-for="(price, key) in selectedItems" :key="price._id" class="tab-section p-2 mb-2">
                  <div class="row align-items-center">
                    <div class="col-6 col-md text-center">
                      <p class="text-muted d-md-none mb-1">{{ $t('Platform') }}</p>
                      <div class="social-image-container d-flex align-items-center justify-content-center">
                        <img v-if="price.price_package_items[0].social_network === 'instagram'"
                             src="@/assets/images/brands/instagram.png" class="img-fluid" style="width:28px;" alt="">
                        <img v-if="price.price_package_items[0].social_network === 'facebook'"
                             src="@/assets/images/brands/facebook.png" class="img-fluid" style="width:28px;" alt="">
                        <img v-if="price.price_package_items[0].social_network === 'youtube'"
                             src="@/assets/images/brands/youtube.png" class="img-fluid" style="width:28px;" alt="">
                        <img v-if="price.price_package_items[0].social_network === 'blog'"
                             src="@/assets/images/brands/analytics-logo.png" class="img-fluid" style="width:28px;"
                             alt="">
                      </div>
                    </div>
                    <div class="col-6 mt-2 order-1 order-md-1 mt-2 mt-md-0 col-md text-center">
                      <p class="text-muted d-md-none mb-1">{{ $t('Post type') }}</p>
                      <h5 class="mb-0"> {{
                          (price.price_package_items[0].post_type.charAt(0).toUpperCase() + price.price_package_items[0].post_type.slice(1)).replace(/_/g, " ")
                        }} </h5>
                    </div>
                    <div class="col-6 col-md order-2 order-md-2 mt-2 mt-md-0 text-center">
                      <p class="text-muted d-md-none mb-1">{{ $t('Giveaway') }}</p>
                      <span v-if="price.price_package_items[0].giveaway"
                            class="badge badge-soft-success font-size-12 ml-1 align-bottom">Yes</span>
                      <span v-else class="badge badge-soft-warning font-size-12 ml-1 align-bottom">No</span>
                    </div>
                    <div class="col-6 col-md order-2 order-md-2 mt-2 mt-md-0 text-center">
                      <p class="text-muted d-md-none mb-1">{{ $t('Event') }}</p>
                      <span v-if="price.price_package_items[0].event"
                            class="badge badge-soft-success font-size-12 ml-1 align-bottom">Yes</span>
                      <span v-else class="badge badge-soft-warning font-size-12 ml-1 align-bottom">No</span>
                    </div>
                    <div class="col-6 col-md order-1 order-md-3 text-center mt-2 mt-md-0">
                      <p class="text-muted d-md-none mb-1">{{ $t('Price') }}</p>
                      <h5 class="mb-0"> {{ price.price_package_items[0].net_price.toLocaleString() }} <span
                          style="font-size: 0.85em;">&euro;</span></h5>
                    </div>
                    <div class="col-12 col-md order-3 order-md-4 text-center mt-2 mt-md-0">
                      <p class="text-muted d-md-none mb-1">{{ $t('Quantity') }}</p>
                      <b-input type="number" min="1" class="quantity-input d-inline" :class="{ error: false }"
                               v-model.number="price.price_package_items[0].quantity"
                               @input="singlePackageError = false"></b-input>
                    </div>
                  </div>
                </div>
                <span class="my-2 d-inline-block text-danger" v-if="singlePackageError">If you have just one item quantity must be greater than 1.</span>
              </div>
            </div>
            <!-- end col -->
          </div>
          <!-- end row -->
        </tab-content>

        <tab-content title="Total">
          <div class="row">
            <div class="col-12 text-center">
              <h5 class="mb-4"> Enter your discounted package price</h5>
              <div>
                <div class="row mb-3">
                  <div class="col-auto d-flex align-items-center"><h5>Package name:</h5></div>
                  <div class="col">
                    <b-input :class="{ 'is-invalid': nameError }" v-model="currentPackage.name"
                             @input="nameError = false"></b-input>
                  </div>
                </div>
                <div class="tab-section tab-list p-1 price-item" v-for="price in currentPackage.price_package_items"
                     :key="price.post_type + price.social_network">
                  <div class="row align-items-center">
                    <div class="order-1 col-auto col-6 col-md text-center mt-2 mt-md-0">
                      <p class="text-muted d-md-none mb-1">{{ $t('Platform') }}</p>
                      <div class="social-image-container d-flex align-items-center justify-content-center">
                        <img v-if="price.social_network === 'instagram'" src="@/assets/images/brands/instagram.png"
                             class="img-fluid" style="width:28px;" alt="">
                        <img v-if="price.social_network === 'facebook'" src="@/assets/images/brands/facebook.png"
                             class="img-fluid" style="width:28px;" alt="">
                        <img v-if="price.social_network === 'youtube'" src="@/assets/images/brands/youtube.png"
                             class="img-fluid" style="width:28px;" alt="">
                        <img v-if="price.social_network === 'blog'" src="@/assets/images/brands/analytics-logo.png"
                             class="img-fluid" style="width:28px;" alt="">
                      </div>
                    </div>
                    <div class="col-6 col-md order-3 order-md-2 mt-2 mt-md-0 text-center">
                      <p class="text-muted d-md-none mb-1">{{ $t('Giveaway') }}</p>
                      <span v-if="price.giveaway"
                            class="badge badge-soft-success font-size-12 ml-1 align-bottom">Yes</span>
                      <span v-else class="badge badge-soft-warning font-size-12 ml-1 align-bottom">No</span>
                    </div>
                    <div class="col-6 col-md order-3 order-md-2 mt-2 mt-md-0 text-center">
                      <p class="text-muted d-md-none mb-1">{{ $t('Event') }}</p>
                      <span v-if="price.event"
                            class="badge badge-soft-success font-size-12 ml-1 align-bottom">Yes</span>
                      <span v-else class="badge badge-soft-warning font-size-12 ml-1 align-bottom">No</span>
                    </div>
                    <div class="col-6 order-2 order-md-3 col-md mt-2 mt-md-0 text-center">
                      <p class="text-muted d-md-none mb-1">{{ $t('Post type') }}</p>
                      <h5 class="mb-0"> {{
                          (price.post_type.charAt(0).toUpperCase() + price.post_type.slice(1)).replace(/_/g, " ")
                        }} </h5>
                    </div>
                    <div class="col-6 order-4 order-md-4 col-md mt-2 mt-md-0 text-center">
                      <p class="text-muted d-md-none mb-1">{{ $t('Price') }}</p>
                      <h5 class="mb-0"> {{ price.net_price.toLocaleString() }} <span
                          style="font-size: 0.85em;">&euro;</span></h5>
                    </div>
                    <div class="col-6 order-1 order-md-5 col-md mt-2 mt-md-0 text-center">
                      <p class="text-muted d-md-none mb-1">{{ $t('Quantity') }}</p>
                      <h5 class="mb-0"> {{ price.quantity }} </h5>
                    </div>
                    <div class="order-5 order-md-6 col-6 mt-2 mt-md-0 col-md-auto text-center">
                      <p class="text-muted d-md-none mb-1">{{ $t('Total price') }}</p>
                      <div class="price-container d-inline d-md-block">
                        <h5 class="mb-0"> {{ (price.net_price * price.quantity).toLocaleString() }} <span
                            style="font-size: 0.85em;">&euro;</span></h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="sum-section mt-1 mb-4">
                <div class="row justify-content-end">
                  <div class="col-auto">
                    <h5>Sum:</h5>
                  </div>
                  <div class="col col-auto text-center">
                    <div class="price-container">
                      <h5 class="mb-0"> {{ sum(currentPackage).toLocaleString() }} <span
                          style="font-size: 0.85em;">&euro;</span></h5>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-end">
                  <div class="col-auto d-flex align-items-center">
                    <h5 class="m-0 align-middle d-inline">Package price:</h5>
                  </div>
                  <div class="col col-auto text-center">
                    <div class="price-container total-price">
                      <b-input type="number" min="1" :class="{ 'is-invalid': totalPriceError }"
                               @input="totalPriceError = false; discountError = false;"
                               v-model.number="currentPackage.total_net_price"></b-input>
                    </div>
                  </div>
                </div>
                <div class="text-center">
                  <span v-if="discountError" class="text-danger my-2">Package price must be lower then Sum (package should be discounted).</span>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>
          <!-- end row -->
        </tab-content>

        <template slot="footer" slot-scope="props">
          <div class="wizard-footer-left">
            <button class="btn btn-primary px-4" v-if="props.activeTabIndex > 0" @click="prevTab">Previous</button>
          </div>
          <div class="wizard-footer-right">
            <button v-if="!props.isLastStep" @click="nextTab" :disabled="!firstStepItemsSelected"
                    class="btn btn-primary px-4 wizard-footer-right">Next
            </button>

            <button v-else @click="savePackage" class="btn btn-primary px-4 wizard-footer-right">
              {{ props.isLastStep ? 'Done' : 'Next' }}
            </button>
          </div>
        </template>
      </form-wizard>
    </b-modal>
  </div>
</template>

<style scoped>
.tab-section h5 {
  font-size: 0.9rem;
}

.price-item {
  background-color: #fbfbfb;
  box-shadow: 0px 0px 0px #ffffff;
  border-radius: 4px;
}

.tab-section.selectable {
  cursor: pointer;
}

.tab-section.selectable:hover {
  background-color: #fbfbfb;
}

.tab-section.selectable.selected {
  background-color: rgba(1, 187, 241, 0.18);
}

.quantity-input {
  width: 65px;
  text-align: center;
}

.quantity-input.error {
  border: 1px solid red;
}

.tab-list {
  border: 0px;
  border-radius: 0px;
  border-bottom: 1px solid #f6f6f6;
  margin-bottom: 0px;
  margin-top: 0px;
}

.tab-list:last-child {
  border: 0px;
}

.price-container {
  width: 170px;
}

.sum-section {
  margin-right: 5px;
  border-top: 2px solid #f6f6f6;
  padding-top: 10px;
}

.social-image-container {
  height: 30px;
}
</style>
